import React from 'react';
import { Col, Form, Select } from 'antd';
import { ITourTransportInfo } from '../../../RefundTypes/RefundTypes';
import { commonProps } from '../../../../../common/types/commonTypes';

type PropsType = {
  transportData?: ITourTransportInfo[];
} & commonProps;

export const SelectTransportRefund = ({
  name,
  label,
  size,
  required,
  disabled,
  transportData,
}: PropsType) => {


  const tourInvoiceDataChildren: React.ReactNode[] = [];
  if (transportData) {
    for (let i = 0; i < transportData.length; i++) {
      tourInvoiceDataChildren.push(
        <Select.Option
          key={transportData[i].itinerary_id}
          value={transportData[i].itinerary_id}
        >
          {`${transportData[i].itinerary_particular}`}
        </Select.Option>
      );
    }
  }
  return (
    <Col span={6} xs={24} sm={24} md={24} lg={size ? size : 8}>
      <Form.Item
        name={name}
        label={label}
        rules={[
          {
            required: required,
            message: 'Select Transport Itenery is required',
          },
        ]}
      >
        <Select
          allowClear
          disabled={disabled}
          placeholder={label}
          showSearch
          style={{ padding: '0', margin: '0', border: '0' }}
          optionFilterProp='roleMobile'
          filterOption={(input, option) =>
            (option!.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          onSelect={(e) => {
          }}
          mode='multiple'
        >
          {tourInvoiceDataChildren}
        </Select>
      </Form.Item>
    </Col>
  );
};
